import { DisplayableUser } from './model'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

type MinimalDisplayableUser = Pick<
  DisplayableUser,
  'familyName' | 'givenName' | 'active' | 'enabled'
>

export function useUserDisplayName() {
  const { t } = useTranslation()

  return useCallback(
    ({ familyName, givenName, active, enabled }: MinimalDisplayableUser) =>
      t(active && enabled ? 'displayName' : 'displayName_inactive', { familyName, givenName }),
    [t],
  )
}
